import mainTheme from 'src/theme'

export default {
  root: {
    padding: 40,
  },
  title: {
    marginTop: 20,
    marginBottom: 20,
  },
  allFieldsMessage: {
    width: '100%',
    textAlign: 'right',
    marginTop: 20,
  },
  buttonsBox: {
    paddingTop: 20,
  },
  buttonSave: {
    marginLeft: 20,
    width: 125,
  },
  buttonCancel: {
    width: 125,
  },
  busyBackdrop: {
    zIndex: 2000,
  },
  busyContent: {
    padding: 40,
    alignItems: 'center',
    justifyContent: 'center',
    display: 'flex',
    flexDirection: 'column',
  },
  busyMessage: {},
  busyWarning: {
    marginBottom: 30,
  },
  successDialog: {
    checkIcon: {
      width: mainTheme.breakpoints.values.sm * 0.75,
      height: mainTheme.breakpoints.values.sm * 0.75,
      color: 'rgba(0, 150, 0, 0.4)',
    },
    successButtonGrid: {
      position: 'absolute',
      top: '0',
      width: '100%',
      height: '100%',
      padding: 20,
    },
  },
  dialogRoot: {
    padding: 40,
  },
}
